import React,{useState,useEffect} from 'react'
import { DashboardLayout } from 'layouts'
import { BreadCrumb,CustomTable } from 'components';
import Divider from '@mui/material/Divider';
import Modals from 'components/Modal';
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { useFormik } from "formik";
import {  string } from "yup";
import * as Yup from "yup";
import { CustomTextField } from 'elements';
import { Button, InputLabel, IconButton } from '@mui/material';
import { ReactComponent as PlusIcon } from "assets/icons/plus-icon.svg";
import { makeStyles } from '@mui/styles';
import styles from "./style";
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from "@mui/material";
import {RiErrorWarningLine} from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux"
import { getAllBuckets, createBucket, downloadLogs, downloadVersionLogs,deleteBucket, updateBucket } from "../../redux/actions/xdata/bucketActions"
import { Spinner } from "reactstrap"
import Swal from 'sweetalert2'
import {useTranslation} from "react-i18next";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/system';
import {getCompanyList} from "../../redux/actions/auth/registerActions";
import {getUserCompanyList} from "../../redux/actions/auth/registerActions";
import { search } from 'components/Search/Search';
import { api_settings } from "../../redux/services/api";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { AiFillCloseSquare } from 'react-icons/ai';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import Grid from '@mui/material/Grid';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const ExporterButton = styled('div')(({ theme }) => ({
    background: '#c8102e',  
    padding: 10, 
    borderRadius: 5, 
    flex: 'none', 
    fontFamily: 'Roboto', 
    cursor: 'pointer', 
    color: '#fff',
    fontSize: 12,
    float: 'right',
    marginBottom: 13,
    "&:hover":{
      background: "#eb314f",
      boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)"
  },
}))

const CustomTextFieldWrappper = styled('div')(({ theme }) => ({
    '& label': {
      fontSize: '1rem !important',
      fontFamily: 'Roboto !important',
      color: '#36333D !important',
    },
    '& input': {
      fontSize: '13px !important',
      padding: "0px 15px 0px 15px !important",
      height: "38px !important"
    },
    '& .MuiFormControl-root': {
       minHeight: "57px !important"
    }
}))

const useStyles = makeStyles(styles)

const SelectContainer = styled('div')(({ theme }) => ({
  '& .label':{
      color:'#000',
      fontFamily:"Roboto",
      fontSize:16,
      fontWeight:500,
      marginBottom:17,
      lineHeight:1,
  },
  [theme.breakpoints.down("xl")]:{
      '& .label':{
      fontSize:`${16-2}px`,
      fontWeight:500,
      marginBottom:12,
      }
  },
  [theme.breakpoints.up("xl")]:{
      '& .label':{
      fontSize:`${20}px`,
      }
  }

}))

const SelectTextField = styled(TextField)(({ theme }) => ({
  backgroundColor:"transparent",
  borderRadius:10,
  minHeight:`${45+23}px`,
  "&  .MuiFormHelperText-root.Mui-error": { //<--- here
      color:"#C8102E"
    },
    "& .MuiInputBase-root":{
      backgroundColor:'#E8E8E8',
      borderRadius:10,
    },
    "& .css-1a1fmpi-MuiInputBase-root-MuiInput-root:before":{
      borderBottom : 'none !important'
    },
    "& .css-1a1fmpi-MuiInputBase-root-MuiInput-root.Mui-error:after":{
      borderBottom : 'none !important'
    },
    "& .css-1a1fmpi-MuiInputBase-root-MuiInput-root:after":{
      borderBottom : 'none !important'
    },
  input:{
      backgroundColor:'#E8E8E8',
      fontFamily:"Roboto",
      fontSize:18,
      fontWeight:300,
      height:44,
      padding:"0px 42px !important",
      borderRadius:10,
      color:'#000',
      "&::placeholder":{
          color:'#000'
      }, 
  },
  [theme.breakpoints.down("xl")]:{
      minHeight:`${45+18}px`,
      input:{
          fontSize:13,
          padding:"0px 37px",
      },
  },
  [theme.breakpoints.up("xl")]:{
      minHeight:`${45+25}px`,
      input:{
          height:`${45+4}px`,
          fontSize:18,
          padding:"0px 37px",
      },
  }

}))

export default function XDataBuckets() {
  const {t} = useTranslation('common');
  const exportDateBoundary = dayjs().subtract(2, 'year');
  const currentBusinessDate = dayjs();
  const { companyListSuccess, userCompanyListSuccess } = useSelector((state) => state.auth.register);
  const [companyList, setCompanyList] = useState([]);
  const [newcompanyList, setNewCompanyList] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [defaultCompany, setDefaultCompany] = useState("");
  const [bucketCode, setBucketCode] = useState("");
  const [bucketName, setBucketName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [userIdentity, setUserIdentity] = useState("");
  
  const [emailSent, setEmailSent ] = useState(false);
  const { impersonateUserInfo } = useSelector((state) => state.impersonate.impersonate);
  
  // State for exporter modal
  const [exporterOpen, setExporterOpen] = useState(false);
  
  const linkData = [ 
    {
        displayName:t('XdataBuckets.XData'),
        link:"/x-data"
    },
    {
        displayName:t('XdataBuckets.Buckets'),
        link:"/xdata/buckets"
    }
  ]

  const thead = [
    {
      name:"code",
      displayName:t('XdataBuckets.Code'),
      type:"text",
      width:20
    },
    {
      name:"name",
      displayName:t('XdataBuckets.Name'),
      type:"text",
      width:35,  //percentage
    },
    {
      name: "company_name",
      displayName: t('XdataBuckets.Company'),
      type:"text",
      width:35
    },
    {
        name:"actions",
        displayName:t('XdataBuckets.Actions'),
        type:"action",
        width:10
    },
  ]

    let navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [btnOpen, setbtnOpen] = useState(false);
    const [bucketlist, setBucketlist] = useState([]);
    const [deleteItem, setDeleteItem] = useState(null);
    const [workspaceAdmin, setWorkspaceAdmin] = useState(null);

    const dispatch = useDispatch();
    const { loading, 
      buckets, 
      createSuccess, 
      downloadLogsLoading, 
      downloadLogsSuccess,
      downloadLogsError,
      downloadVersionLogsLoading, 
      downloadVersionLogsSuccess,
      deleteBucketLoading, 
      deleteBucketSuccess,
      create500Error,
      deleteBucketError500,
      downloadLogs500Error,
      downloadVersionLogs500Error,
      updateLoading,
      updateSuccess,
      updateError,
      error} = useSelector((state) => state.xdata.buckets);
    const [page, setPage] = useState(1)
    const [allusersCount, setAllUsersCount] = useState(0);
    const { user } = useSelector((state) => state.auth.login);
   
  
    const handleOpen = () => {
      setDefaultCompany("")
      setCompanyId(user.company)
      formik.setFieldValue("company", user.company_name)
      setOpen(true)
    };

    // added new if condition to reset only bucket name of form only for new users 
    const handleClose = () => {
      if(userIdentity === 'no'){
        formik.setFieldValue("bucket", "")
        setBucketCode("")
        setBucketName("")
        setDefaultCompany("")
        setOpen(false);
      }
      else{
        formik.resetForm();
        setBucketCode("")
        setBucketName("")
        setCompanyId("")
        setDefaultCompany("")
        setOpen(false);
      }
    }


    // identify @corob.com user and other domain users.
    useEffect(() => {  
      let name = null
        if(impersonateUserInfo?.status === "success"){
          let impersonateUserInfoData = impersonateUserInfo?.data
          name = impersonateUserInfoData.email;
        }
        else {
          name = user.email;
        }
        const domname = ["corob"];
        const data = name.split('@')[1].split(".")[0].toLowerCase();
        if (domname.includes(data)) {
              setUserIdentity("yes")
        } 
      else {
        setUserIdentity("no")
        }
    }, [])

    const buttonClose = () => setbtnOpen(false);

    const handleDeleteClick = (item) => (e) => {
      e.stopPropagation()
      setDeleteItem(item)
      setbtnOpen(true)
    }

    const handleDeleteConfirm = () => {          
      dispatch(deleteBucket(deleteItem)) 
    } 

    

    const formik = useFormik({
        initialValues: {
          bucket: "",
          company: "", 
        },
        validationSchema: Yup.object({        
          company: string().required(t("XdataBuckets.SelectCompanyname")), 
          bucket: string().required(t('XdataBuckets.Pleaseenterbucket')).max(255,t('XdataBuckets.Bucketnametoolong')),                    
        }),
        onSubmit : (values, formikHelpers)=> {
          if(bucketCode === ""){
            dispatch(createBucket(values, companyId)) 
          }
          else{
            if(companyId === defaultCompany && bucketName === values.bucket){
              toast.error(t("XdataBuckets.noChanges") , {
                duration: 8000,
                position: 'top-right',
                style: {fontSize: 20, fontFamily: 'Roboto'}
              })
            }
            else{
              dispatch(updateBucket(values, companyId, bucketCode)) 
            }
            
          }
        }
    });

    // Formik for exporter with date filters
    
    const exporterFormik = useFormik({
        initialValues: {
            startdate: "",
            enddate: "",
            date_type_analytics: "lastyear",
        },
        validationSchema: Yup.object({
            startdate: Yup.string().when(
    "date_type_analytics",
    {
      is: "custom",

      then: Yup.string()

        .required("Start Date is required")

        .test(
          "start-not-future",
          "Future dates are not allowed",
          value => {
            if (!value) return true;

            return !dayjs(value).isAfter(currentBusinessDate, "day");
          }
        )

        .test(
          "start-within-2-years",
          "Only last 2 years data can be exported",
          value => {
            if (!value) return true;

            return !dayjs(value).isBefore(exportDateBoundary, "day");
          }
        )

        .test(
          "start-before-end",
          "Start Date cannot be after End Date",
          function(value) {

            const { enddate } = this.parent;

            if (!value || !enddate) {
              return true;
            }

            return dayjs(value).isSameOrBefore(dayjs(enddate));
          }
        )
    }
  ),

  enddate: Yup.string().when(
    "date_type_analytics",
    {
      is: "custom",

      then: Yup.string()

        .required("End Date is required")

        .test(
          "end-not-future",
          "Future dates are not allowed",
          value => {
            if (!value) return true;

            return !dayjs(value).isAfter(currentBusinessDate, "day");
          }
        )

        .test(
          "end-within-2-years",
          "Only last 2 years data can be exported",
          value => {
            if (!value) return true;

            return !dayjs(value).isBefore(exportDateBoundary, "day");
          }
        )

        .test(
          "end-after-start",
          "End Date cannot be before Start Date",
          function(value) {

            const { startdate } = this.parent;

            if (!value || !startdate) {
              return true;
            }

            return dayjs(value).isSameOrAfter(dayjs(startdate));
                    }
                )
        }),                                                              
        }),
        onSubmit: (values, formikHelpers) => {
            let payload = {
                date_type: values.date_type_analytics
            };
            
            // If custom range, add start and end dates
            if (values.date_type_analytics === "custom") {
                payload.start_date = values.startdate;
                payload.end_date = values.enddate;
            } else {
                // Calculate dates based on selection
                const now = new Date();
                let startDate = new Date();
                let endDate = new Date();
                
                switch(values.date_type_analytics) {
                    case "lastyear":
                        startDate.setFullYear(now.getFullYear() - 1);
                        startDate.setMonth(0, 1);
                        endDate.setFullYear(now.getFullYear() - 1);
                        endDate.setMonth(11, 31);
                        break;
                    case "thisyear":
                        startDate.setFullYear(now.getFullYear());
                        startDate.setMonth(0, 1);
                        endDate = new Date();
                        break;
                    case "lastmonth":
                        startDate.setMonth(now.getMonth() - 1);
                        startDate.setDate(1);
                        endDate.setMonth(now.getMonth() - 1);
                        endDate.setDate(new Date(now.getFullYear(), now.getMonth(), 0).getDate());
                        break;
                    case "thismonth":
                        startDate.setDate(1);
                        endDate = new Date();
                        break;
                    default:
                        break;
                }
                
                // Format dates as YYYY-MM-DD
                const formatDate = (date) => {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                };
                
                payload.start_date = formatDate(startDate);
                payload.end_date = formatDate(endDate);
            }
            
            // Call download logs with date filter
            dispatch(downloadLogs(payload));
            // setExporterOpen(false); #for closing the popup immediately
        }
    });

    const theme = useTheme();
    const isSmallerDesktop = useMediaQuery(theme.breakpoints.down('xl'));

    const handleRowClick = (item) => () => {
      navigate("/dashboard/xdata/buckets/details/"+item.code+"/")
    }  

    const handleEditClick = (item) => () => {
        formik.setFieldValue("bucket", item.name)
        formik.setFieldValue("company", item.company_name ? item.company_name : "")
        setDefaultCompany(item.company)
        setCompanyId(item.company)
        setBucketCode(item.code)
        setBucketName(item.name)
        setOpen(true)
    }
    
    const handleDownloadLogs = () => {            
      // dispatch(downloadLogs())  # for downlaoding without formik
      console.log("Download button clicked");
      setExporterOpen(true);

    }  

    // const handleDownloadVersionLogs = () => {            
    //   dispatch(downloadVersionLogs()) 
    // }  

    const handleExporterClose = () => {
        exporterFormik.resetForm();
        setExporterOpen(false);
    }

    const headerActions = (
        <>
            <Button onClick={handleOpen}><PlusIcon /> {t('XdataBuckets.CreateNew')}</Button>
            <Button onClick={handleDownloadLogs} style={{marginLeft:30}}><FileDownloadOutlinedIcon />
              {downloadLogsLoading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : t('XdataBuckets.DownloadsLog')}</Button>
              {/* # currently not showing version logs download button as per discussion with team, 
              will enable it once the api integration done on POS, kept the code for future use. */}
            {/* <Button onClick={handleDownloadVersionLogs} style={{marginLeft:10}}><FileDownloadOutlinedIcon />
              {downloadVersionLogsLoading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : t('XdataBuckets.DownloadsposLog')}</Button>  */}
        </>
      )

    const bigHtmlContent = (
        <>
            <div className={classes.head}>{t('XdataBuckets.CreateBucket')}</div>
            <Divider  className={classes.divide}/>
            <form onSubmit={formik.handleSubmit}>
              <CustomTextField              
                  label={t('XdataBuckets.Bucketname')}
                  name="bucket"
                  type="name"
                  placeholder={t('XdataBuckets.Bucketname')}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bucket}
                  error={formik.touched.bucket && Boolean(formik.errors.bucket)}
                  helperText={formik.touched.bucket && formik.errors.bucket} 
                  labelColor="#000"
                  labelTextSize={16}
                  inputbackgroundcolor="#E8E8E8"
                  inputtextcolor="#000"
                  placeholdercolor="#A5A5A5"
                  helpertextcolor="#C8102E"  
                  height={56}            
              />
              <Autocomplete
                  noOptionsText={
                    <>
                        <p>{t("companyAdd.doesnotExist")} <a style={{color: "#C8102E", cursor: 'pointer'}} onClick={() => viewMoreClick()}>{t("companyAdd.viewMore")}</a></p>
                  </>}
                    sx={{ width: '100%' }}
                    options={companyList}
                    autoHighlight
                    isOptionEqualToValue={(option, value) => option.company_name === value.company_name}
                    getOptionLabel={(option) => option.company_name}                   
                    renderOption={(props, option) => (
                        <Box  component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        
                        {option.company_name}
                        </Box>
                    )}
                    onChange={(event, newValue) => {
                        setCompanyId(JSON.stringify(newValue.id))
                      }}
                      defaultValue={bucketCode === "" ? {company_name: user.company_name}:{ company_name: formik.values.company ? formik.values.company : ""}}
                    renderInput={(params) => (
                        
                        
                        <SelectContainer labelColor={'#FFFFFF'} labelTextSize={16}>
                            <InputLabel className='label' required={true}>{t('XdataBuckets.Company')}</InputLabel>
                            <SelectTextField
                            variant="standard"
                            type="text"                                
                            name="company"
                            id="as"
                            {...params}
                            placeholder={t('signUp.company')}
                            value={formik.values.company}
                            onChange={formik.handleChange}
                            onBlur={() =>formik.setFieldValue("company", params.inputProps.value)}
                            // onFocus={() =>formik.setFieldValue("country", params.inputProps.value)}
                            error = {formik.touched.company && Boolean(formik.errors.company)}
                            helperText = {formik.touched.company && formik.errors.company}
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password'
                            }}
                            />
                        </SelectContainer>
                    )}
                    />             
              
              <div className={classes.buttons} >                   
                  <Button         
                      size="small"
                      className='appBtnCancel'
                      onClick={handleClose}
                  >
                      {t('XdataBuckets.Cancel')}
                  </Button>                                          
                  <div className={classes.sub}>
                      <Button                  
                        type="submit"
                        size="meduim"
                        className='appBtn'
                      >
                         {loading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : updateLoading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : bucketCode === "" ? t('XdataBuckets.Create') : t('WorkspaceUsers.Update')}
                      </Button>
                  </div>                                         
              </div>   
            </form> 
        </>
      )

      //  added Html for non corob users to create bucket
      const bigHtmlContentnew = (
        <>
            <div className={classes.head}>{t('XdataBuckets.CreateBucket')}</div>
            <Divider  className={classes.divide}/>
            <form onSubmit={formik.handleSubmit}>
              <CustomTextField              
                  label={t('XdataBuckets.Bucketname')}
                  name="bucket"
                  type="name"
                  placeholder={t('XdataBuckets.Bucketname')}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.bucket}
                  error={formik.touched.bucket && Boolean(formik.errors.bucket)}
                  helperText={formik.touched.bucket && formik.errors.bucket} 
                  labelColor="#000"
                  labelTextSize={16}
                  inputbackgroundcolor="#E8E8E8"
                  inputtextcolor="#000"
                  placeholdercolor="#A5A5A5"
                  helpertextcolor="#C8102E"  
                  height={56}            
              />

                <CustomTextField 
                            label={t('signUp.company')}
                            name="company"
                            type="name" 
                            placeholder={t('signUp.company')}
                            onChange={formik.handleChange} 
                            onBlur={() =>formik.setFieldValue("company", companyName)}
                            value={companyName} 
                            error = {formik.touched.company && Boolean(formik.errors.company)} 
                            helperText = {formik.touched.company && formik.errors.company}
                            height={45}
                            labelColor="#000"
                            labelTextSize={16}
                            inputbackgroundcolor="#E8E8E8"
                            inputtextcolor="#000"
                            placeholdercolor="#A5A5A5"
                            helpertextcolor="#C8102E"
                            // required={false}
                            disabled={true}
                        />
              
              <div className={classes.buttons} >                   
                  <Button         
                      size="small"
                      className='appBtnCancel'
                      onClick={handleClose}
                  >
                      {t('XdataBuckets.Cancel')}
                  </Button>                                          
                  <div className={classes.sub}>
                      <Button                  
                        type="submit"
                        size="meduim"
                        className='appBtn'
                      >
                         {loading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : updateLoading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : bucketCode === "" ? t('XdataBuckets.Create') : t('WorkspaceUsers.Update')}
                      </Button>
                  </div>                                         
              </div>   
            </form> 
        </>
      )

      const bigHtmlContent1 = (
        <>
          <div className={classes.logo1}>
              <RiErrorWarningLine color="#C8102E" size={"100px"} />
          </div>
          <div className={classes.warning}>
              {t('XdataBuckets.AreYouSure')}
          </div>
          <div className={classes.text} >                
          {t('XdataBuckets.Youareabouttodeletetheentirebucket')}              
          </div>
          <div className={classes.button2}>
            <Button      
              onClick={buttonClose}                                  
              size="large"
              className='appBtnCancel' 
            >
              {t('XdataBuckets.Cancel')}
            </Button>
            <div className={classes.ok}>
              <Button 
              className='appBtn'                        
                size="large"
                onClick={handleDeleteConfirm}      
              > {deleteBucketLoading ? <Spinner size="sm">{t('common.Loading')}</Spinner> : t('XdataBuckets.OK')}</Button>
            </div>
          </div>
        </>     
      )
      // Exporter Modal Content - Dialog box
      const exporterContent = (
        <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '2px 20px',
                marginBottom: 0
              }}
            >
              <div
                style={{
                  fontSize: '30px',
                  fontWeight: 500,
                  fontFamily: 'Roboto'
                }}
              >
                {t('XdataBuckets.DownloadsLog')}
              </div>

              <IconButton onClick={handleExporterClose}
                  style={{ padding: 0 }}
              >
                <AiFillCloseSquare color="#C8102E" size="30px" />
              </IconButton>
            </div>

            <Divider />
            <Divider />
            <div style={{padding: '20px 24px'}}>
                <form onSubmit={exporterFormik.handleSubmit}>
                    <InputLabel style={{fontFamily: 'Roboto', fontSize: 16, fontWeight: 500, marginBottom: 10}}>Date Type</InputLabel>
                    <RadioGroup 
                        name='date_type_analytics' 
                        value={exporterFormik.values.date_type_analytics}
                        style={{display: 'inline-block'}}
                        onChange={(e) => {
                            exporterFormik.handleChange(e);
                            // Reset date fields when switching from custom
                            if (e.target.value !== 'custom') {
                                exporterFormik.setFieldValue('startdate', '');
                                exporterFormik.setFieldValue('enddate', '');
                            }
                        }}
                    >
                        <FormControlLabel 
                            value="lastyear" 
                            control={<Radio style={{color: "#C8102E"}} />} 
                            label="Last Year"
                        />
                        <FormControlLabel 
                            value="thisyear" 
                            control={<Radio style={{color: "#C8102E"}} />} 
                            label="This Year"
                        />
                        <FormControlLabel 
                            value="lastmonth" 
                            control={<Radio style={{color: "#C8102E"}} />} 
                            label="Last Month"
                        />
                        <FormControlLabel 
                            value="thismonth" 
                            control={<Radio style={{color: "#C8102E"}} />} 
                            label="This Month"
                        />
                        <FormControlLabel 
                            value="custom" 
                            control={<Radio style={{color: "#C8102E"}} />} 
                            label="Custom"  
                        />
                    </RadioGroup>

                    {exporterFormik.values.date_type_analytics === "custom" && (
                        <Grid container spacing={2} style={{marginTop: 10}}>
                            <Grid item xs={6}>
                                <InputLabel style={{fontFamily: 'Roboto', fontSize: 14, fontWeight: 500, marginBottom: 5}}>Start Date *</InputLabel>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                      minDate={exportDateBoundary}
                                      maxDate={
                                          exporterFormik.values.enddate
                                              ? dayjs(exporterFormik.values.enddate)
                                              : currentBusinessDate
                                      }
                                      value={
                                          exporterFormik.values.startdate
                                              ? dayjs(exporterFormik.values.startdate)
                                              : null
                                      }
                                      onChange={(value) => {
                                          exporterFormik.setFieldTouched("startdate", true);

                                          if (!value) {
                                              exporterFormik.setFieldValue("startdate", "");
                                              return;
                                          }

                                          exporterFormik.setFieldValue(
                                              "startdate",
                                              value.format("YYYY-MM-DD")
                                          );
                                      }}
                                        renderInput={(params) => 
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                error={exporterFormik.touched.startdate && Boolean(exporterFormik.errors.startdate)}
                                                helperText={exporterFormik.touched.startdate && exporterFormik.errors.startdate}
                                                placeholder="Select Date"
                                                {...params}
                                                sx={{
                                                    '& .MuiFilledInput-root': {
                                                        backgroundColor: '#F3F3F4',
                                                        borderRadius: 1,
                                                        '&:before': { borderBottom: 'none' },
                                                        '&:after': { borderBottom: 'none' },
                                                        '&:hover:before': { borderBottom: 'none' }
                                                    }
                                                }}
                                            />
                                        } 
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={6}>
                                <InputLabel style={{fontFamily: 'Roboto', fontSize: 14, fontWeight: 500, marginBottom: 5}}>End Date *</InputLabel>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        minDate={
                                            exporterFormik.values.startdate
                                                ? dayjs(exporterFormik.values.startdate)
                                                : exportDateBoundary
                                        }
                                        maxDate={currentBusinessDate}
                                        value={
                                            exporterFormik.values.enddate
                                                ? dayjs(exporterFormik.values.enddate)
                                                : null
                                        }
                                        onChange={(value) => {
                                            exporterFormik.setFieldTouched("enddate", true);

                                            if (!value) {
                                                exporterFormik.setFieldValue("enddate", "");
                                                return;
                                            }

                                            exporterFormik.setFieldValue(
                                                "enddate",
                                                value.format("YYYY-MM-DD")
                                            );
                                        }}
                                        renderInput={(params) => 
                                            <TextField
                                                fullWidth
                                                variant="filled"
                                                error={exporterFormik.touched.enddate && Boolean(exporterFormik.errors.enddate)}
                                                helperText={exporterFormik.touched.enddate && exporterFormik.errors.enddate}
                                                placeholder="Select Date"
                                                {...params}
                                                sx={{
                                                    '& .MuiFilledInput-root': {
                                                        backgroundColor: '#F3F3F4',
                                                        borderRadius: 1,
                                                        '&:before': { borderBottom: 'none' },
                                                        '&:after': { borderBottom: 'none' },
                                                        '&:hover:before': { borderBottom: 'none' }
                                                    }
                                                }}
                                            />
                                        } 
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    )}

                    <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 30}}>
                        <Button 
                            className='appBtnCancel'
                            size="small"
                            onClick={handleExporterClose}
                            style={{marginRight: 10}}
                        >
                            Cancel
                        </Button>
                        <Button
                            className='appBtn'
                            type="submit"
                            size="meduim"
                        >
                            {downloadLogsLoading ? <Spinner size="sm">Loading...</Spinner> : 'Export'}
                        </Button>
                    </div>
                </form>
            </div>
        </>
      )

      useEffect(() => {  
        let paginationPage = page;
        let paginationOffset = 0;
        if(page > 1){
          paginationPage = paginationPage - 1;
          paginationPage = paginationPage * 10;
          paginationOffset = paginationPage;
        }
        let payload = {
          offset: paginationOffset
        }  
        dispatch(getAllBuckets(payload)) 
        dispatch(getCompanyList())
        
        if(createSuccess){
          
          handleClose()
          Swal.fire({
            title: t('XdataBuckets.Success'),
            text: t('XdataBuckets.BucketCreated'),
            icon: 'success',
            iconColor: '#C8102E',
            confirmButtonColor: '#C8102E'
          })
        }      
        if(deleteBucketSuccess){
          setbtnOpen(false)
          let payload = {
            offset: 0
          }  
          setPage(1)
          dispatch(getAllBuckets(payload))
          Swal.fire({
            title: t('XdataBuckets.Success'),
            text: t('XdataBuckets.BucketDeleted'),
            icon: 'success',
            iconColor: '#C8102E',
            confirmButtonColor: '#C8102E'
          })
        }  
    
      },[createSuccess, deleteBucketSuccess]);

      useEffect(() => { 
        if(updateSuccess){
          handleClose()
          let payload = {
            offset: 0
          }  
          setPage(1)
          dispatch(getAllBuckets(payload))
          Swal.fire({
            title: t('XdataBuckets.Success'),
            text: t('XdataBuckets.BucketUpdated'),
            icon: 'success',
            iconColor: '#C8102E',
            confirmButtonColor: '#C8102E'
          })
          dispatch({
            type: "REQUEST_UPDATE_BUCKET_SUCCESS",
            payload: null
          });
          formik.resetForm()
        }
      }, [updateSuccess, updateError])

      useEffect(() => {  
        if(buckets?.data){
          var searchResult =  search(buckets?.data, searchText)
          if(searchResult && searchText !== ""){
            var firstIndex = (page * 10) - 10
            var lastIndex = (page * 10)
            const productArrayFiltered = searchResult.slice(firstIndex, lastIndex);
            setBucketlist(productArrayFiltered)
            setAllUsersCount(searchResult.length)
          }
          else{
              var firstIndex = (page * 10) - 10
              var lastIndex = (page * 10)
              const productArrayFiltered = buckets.data.slice(firstIndex, lastIndex);
              setBucketlist(productArrayFiltered)
              setAllUsersCount(buckets.data.length)
            }
        }
      }, [buckets, page])


      // added condition to identify impersoneted user company.
      useEffect(() => {  
        if(bucketCode === ""){
          if(impersonateUserInfo?.status === "success"){
            let impersonateUserInfoData = impersonateUserInfo?.data
            setDefaultCompany("")
            setCompanyId(impersonateUserInfoData.company)
            formik.setFieldValue("company", impersonateUserInfoData.company_name)
          }
          else {
            setDefaultCompany("")
            setCompanyId(user.company)
            formik.setFieldValue("company", user.company_name)
          }
        }else{
          
        }
      }, [bucketCode])


      

      useEffect(() => {
        setWorkspaceAdmin(user.is_workspace_admin)
      }, [user])

      useEffect(() => {    
        if(companyListSuccess) {
            setCompanyList(companyListSuccess.data)
        }
      },[companyListSuccess]);

      // fetch user company (impersonet/normal) from api 
      useEffect(() => {
        let companyId = null;
        if(impersonateUserInfo?.status === "success"){
          let impersonateUserInfoData = impersonateUserInfo?.data
          companyId = impersonateUserInfoData.company;
        }
        else {
          companyId = user.company;
        }
        let payload = {
          companyid: companyId
        }  
        dispatch(getUserCompanyList(payload))
      },[])

      useEffect(() => {    
        if(userCompanyListSuccess) {
          setNewCompanyList(userCompanyListSuccess.data)
          setCompanyName(userCompanyListSuccess.data[0].company_name)
        }
      },[userCompanyListSuccess]);

      const errorBlockBtnClick = () => {
        let paginationPage = page;
        let paginationOffset = 0;
        if(page > 1){
          paginationPage = paginationPage - 1;
          paginationPage = paginationPage * 10;
          paginationOffset = paginationPage;
        }
        let payload = {
          offset: paginationOffset
        }  
        dispatch(getAllBuckets(payload))
      }

      useEffect(() => {  
        if(downloadLogsSuccess){
          // const url = new Blob([downloadLogsSuccess.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downloadLink = document.createElement('a');
          downloadLink.href = api_settings.url_base + downloadLogsSuccess.data.url;
          // downloadLink.download = 'example.xlsx';

          // Append the link to the body and trigger a click
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // Cleanup: Remove the link from the DOM
          document.body.removeChild(downloadLink);
          dispatch({
            type: "REQUEST_DOWNLOAD_XDATA_LOGS_SUCCESS",
            payload: null
          });

        }
        // if(downloadLogsSuccess?.status === 'success'){
        //   var base64replace1 = downloadLogsSuccess.data.replace("b'", "");
        //   var base64replace2 = base64replace1.replace("'", "");
          
        //   var contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        //   var blob1 = b64toBlob(base64replace2, contentType);
        //   const blobUrl = URL.createObjectURL(blob1);
        //   var a = document.createElement("a");
        //   document.body.appendChild(a);
        //   a.style = "display: none";
        //     a.href = blobUrl;
        //     a.download = "downloads-log";
        //     a.click();
        //     dispatch({
        //       type: "REQUEST_DOWNLOAD_XDATA_LOGS_SUCCESS",
        //       payload: null
        //     });
        // }
      }, [downloadLogsSuccess])

      useEffect(() => {  
        if(downloadVersionLogsSuccess){
          // const url = new Blob([downloadVersionLogsSuccess.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downloadLink = document.createElement('a');
          downloadLink.href = api_settings.url_base + downloadVersionLogsSuccess.data.url;
          // downloadLink.download = 'example.xlsx';

          // Append the link to the body and trigger a click
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // Cleanup: Remove the link from the DOM
          document.body.removeChild(downloadLink);
          dispatch({
            type: "REQUEST_DOWNLOAD_VERSION_LOGS_SUCCESS",
            payload: null
          });

        }
      }, [downloadVersionLogsSuccess])


      
      const b64toBlob =(b64Data, contentType, sliceSize) =>  {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
        
          var byteArray = new Uint8Array(byteNumbers);
          
          byteArrays.push(byteArray);
        }
        
        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }

      useEffect(() => {  
        if(create500Error){
          toast.error(t('XdataBuckets.bucketCreateFailed') , {
            duration: 8000,
            position: 'top-right',
            style: {fontSize: 20, fontFamily: 'Roboto'}
          });
          dispatch({
            type: "REQUEST_CREATE_BUCKET_FAILED_500",
            payload: null
          })
        }
    
        if(downloadLogsError){
          // Check if the error is an object with message or a string
          let errorMessage = "Failed to download logs";
          if (typeof downloadLogsError === 'string') {
            errorMessage = downloadLogsError;
          } else if (downloadLogsError && typeof downloadLogsError === 'object') {
            errorMessage = downloadLogsError.message || downloadLogsError.error || "Failed to download logs";
          }
          
          toast.error(errorMessage, {
            duration: 8000,
            position: 'top-right',
            style: {
              fontSize: 20,
              fontFamily: 'Roboto'
            }
          });

          dispatch({
            type: "REQUEST_DOWNLOAD_XDATA_LOGS_FAILED",
            payload: null
          });
        }

        if(deleteBucketError500){
          toast.error(t('XdataBuckets.xdataDeleteFailed'), {
            duration: 8000,
            position: 'top-right',
            style: {fontSize: 20, fontFamily: 'Roboto'}
          });
          dispatch({
            type: "REQUEST_DELETE_BUCKET_FAILED_500",
            payload: null
          })
        }

        if(downloadVersionLogs500Error){
          toast.error(t('XdataBuckets.downloadVersionLogsFailed'), {
            duration: 8000,
            position: 'top-right',
            style: {fontSize: 20, fontFamily: 'Roboto'}
          });
          dispatch({
            type: "REQUEST_DOWNLOAD_VERSION_LOGS_FAILED_500",
            payload: null
          })
        }
        
      }, [create500Error, downloadLogs500Error, deleteBucketError500, downloadVersionLogs500Error])

      const viewMoreClick = () => {
        setEmailSent(true)
      }
    
      const emailSentClose = () => {
        setEmailSent(false)
      }
    
      const emaailSentContent = (
        <>
          <div className={classes.emailtext}>      
            {t("companyAdd.infoText")} <br/>  <span style={{color: '#C8102E'}}> {process.env.REACT_APP_EMAIL_ID}</span> {t("companyAdd.followingDetails")}
            
          </div>
          <ul style={{paddingLeft: 40, fontFamily: 'Roboto',display: 'grid',
          gridTemplateColumns: 'repeat(2, auto)'}}>
          <li>{t("companyAdd.companyname")}</li>
          <li>{t("companyAdd.country")}</li>
          <li>{t("companyAdd.city")}</li>
          <li>{t("companyAdd.address")}</li>
          <li>{t("companyAdd.zipcode")}</li>
          <li>{t("companyAdd.phone")}</li>
          <li>{t("companyAdd.vat")}</li>
          </ul>
          <div className={classes.emailbutton}>
                      <Button
                      
                      variant="contained" 
                      onClick={() => setEmailSent(false)}
                      size="medium"
                      >
                          {t("companyAdd.close")}
                      </Button>
          </div> 
    
        </>
    );

  return (
    <DashboardLayout pageLoading={downloadLogsLoading}>
      <Toaster />
        <BreadCrumb linkData={linkData}/>
        
        <CustomTable 
            loading={loading}
            totalPageCount={allusersCount}
            title ={t('XdataBuckets.XDataBuckets')}
            thead={thead}
            tdata={bucketlist}
            maxRow={10}
            handleRowClick={handleRowClick}
            handleDeleteClick={handleDeleteClick} 
            handleEditClick={handleEditClick}           
            headerActions={headerActions}
            height={isSmallerDesktop?617:767}
            loadPagination={setPage}
            action={
               { 
                default: workspaceAdmin ?  ["edit", "delete"] : ["delete"],
               }
              }
            currentPage={page}
            clickableColumn={0}
            errorStatus={error}
            errorBlockBtnClick={errorBlockBtnClick}
        />
        { userIdentity === "yes" ? (
          <Modals 
            handleclose={handleClose} 
            open={open} 
            content={bigHtmlContent}                   
          />) : (
            <Modals 
            handleclose={handleClose} 
            open={open} 
            content={bigHtmlContentnew}                   
          />
          )
        }
        <Modals 
            handleclose={buttonClose} 
            open={btnOpen} 
            content={bigHtmlContent1}                   
        />  
        <Modals handleclose={emailSentClose} open={emailSent} content={emaailSentContent} />
        
        {/* Exporter Modal */}
        <Modals 
            handleclose={handleExporterClose} 
            open={exporterOpen} 
            content={exporterContent}
        />            
       
    </DashboardLayout>
  )
}
